import { render } from "./sidebarComponent.vue?vue&type=template&id=1d6c1e20&scoped=true"
import script from "./sidebarComponent.vue?vue&type=script&lang=js"
export * from "./sidebarComponent.vue?vue&type=script&lang=js"

import "./sidebarComponent.vue?vue&type=style&index=0&id=1d6c1e20&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1d6c1e20"]])

export default __exports__